import React, { createContext, PropsWithChildren, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

interface ContextType {
  loading: () => boolean;
  startLoading: () => string;
  endLoading: (loadingId: string) => void;
}

export const LoadingContext = createContext<ContextType>({
  loading: () => false,
  startLoading: () => '',
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  endLoading: (loadingId) => {},
});

function generateLoadingId(): string {
  return new Date().getTime().toString();
}

export function LoadingProvider(props: PropsWithChildren<any>) {
  const { children } = props;

  const [loadings, setLoadings] = useState<string[]>([]);

  const loading = () => loadings.length !== 0;

  const startLoading = (): string => {
    const newLoadingId = generateLoadingId();
    setLoadings((loads) => [...loads, newLoadingId]);
    return newLoadingId;
  };
  const endLoading = (loadingId: string) => {
    setLoadings((loads) => loads.filter((id) => id !== loadingId));
  };

  return (
    <LoadingContext.Provider value={{ loading, startLoading, endLoading }}>
      {loading() && (
        <div className="absolute top-0 bottom-0 z-50 w-screen h-screen flex items-center justify-center bg-white bg-opacity-50">
          <FontAwesomeIcon
            icon={faSpinner}
            size="4x"
            className="animate-spin text-gray-500"
          />
        </div>
      )}
      {children}
    </LoadingContext.Provider>
  );
}
